import Vue from 'vue';

Vue.component('global-filter', require('./GlobalFilter').default);
Vue.component('modal', require('./Modal').default);
Vue.component('button-loading', require('./ButtonLoading').default);
Vue.component('input-text', require('./InputText').default);
Vue.component('input-search', require('./InputSearch').default);
Vue.component('input-date', require('./InputDate').default);
Vue.component('international-twilio-phone', require('./InternationalTwilioPhone').default);
Vue.component('tags', require('./Tags').default);
Vue.component('pagination', require('./Pagination').default);
Vue.component('swell-switch', require('./SwellSwitch').default);
Vue.component('upload-image', require('./UploadImage').default);
Vue.component('pie-progress', require('./PieProgress').default);
Vue.component('progress-bar', require('./ProgressBar').default);
Vue.component('rating-stars', require('./RatingStars').default);
Vue.component('swell-code', require('./SwellCode').default);
Vue.component('spinner', require('./Spinner').default);
Vue.component('text-expand', require('./TextExpand').default);
Vue.component('file-uploader', require('./FileUploader').default);
Vue.component('colorpicker', require('./ColorPicker').default);
Vue.component('draw-opened', require('./draw/opened').default);
Vue.component('draw-empty', require('./draw/empty').default);
Vue.component('drag-drop-file-uploader', require('./DragDropFileUploader').default);


require('./grid');
require('./card');
require('./navs');
require('./elements');
